import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=95915cd4&"
import script from "./MagicLink.vue?vue&type=script&lang=js&"
export * from "./MagicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports